import { FunctionComponent, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { dismissModalAction } from '@/redux/modal/actions/dismissModalAction';
import { StoreDispatch, StoreState } from '@/redux/types';
import { AsyncDesignUploadDialog } from '@/components/common/filters/AsyncDesignUploadDialog';
import { AppearanceSwitchDialog } from './AppearanceSwitchDialog';
import { ProductTypeSwitchDialog } from './ProductTypeSwitchDialog';

export interface ModalProps {
  dismiss: () => void;
}

export const ModalManager: FunctionComponent = () => {
  const dispatch = useDispatch<StoreDispatch>();
  const modal = useSelector((state: StoreState) => state.modal);
  const dismiss = useCallback(() => {
    dispatch(dismissModalAction);
  }, [dispatch]);

  if (modal) {
    switch (modal.type) {
      case 'AppearanceSwitch':
        return <AppearanceSwitchDialog {...modal.props} dismiss={dismiss} />;
      case 'ProductTypeSwitch':
        return <ProductTypeSwitchDialog {...modal.props} dismiss={dismiss} />;
      case 'DesignUpload':
        return <AsyncDesignUploadDialog {...modal.props} dismiss={dismiss} />;
      default:
        return null;
    }
  }
  return null;
};
